import AuthProvider from '@/services/auth.provider'
const authService = new AuthProvider()

const initialState = {
    user: null,
    login_status: false,
    sidebar_status: null,
};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        async getUserInfo({ commit, state }) {
            if (state.user === null) {
                const data = await authService.getUserInfo();
                if (data && (data.admission.status || data.delegated_officer.status)) {
                    commit('set_user', data);
                    commit('set_login_status', true);
                    if (data && data.admission.status) {
                        const data_sidebar = await authService.getSidebarStatus();
                        commit('set_sidebar_status', data_sidebar);
                    }
                }
            }
        },
        async logout({ commit, state }) {
            if (state.user !== null) {
                await authService.logout();
                commit('set_user', null);
                commit('set_login_status', false);
            }
        },

        async getSidebarStatus({ commit }) {
            const data = await authService.getSidebarStatus();
            commit('set_sidebar_status', data);
        },
    },
    mutations: {
        set_user(state, data) { state.user = data },
        set_login_status(state, data) { state.login_status = data },
        set_sidebar_status(state, data) { state.sidebar_status = data },
    },
};